import LoadingState from '../../components/LoadingState';
import { useTranslation } from '../../i18n/i18n';

export default function InitContent() {
  const { t } = useTranslation();
  return <LoadingState title={t('init.title')} subtitle={t('init.hint')} />;
}
